import { instance } from "api/apiBase";
import { FeedConnectPayload } from "api/syndicationFeed";

interface UloopConnectionStatus {
  connected: boolean;
  featured_opted_in: boolean;
  auto_add_listings: boolean;
}

export type UloopConnectPayload = FeedConnectPayload & {
  featured_opted_in?: boolean;
};

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/uloop";

export const uloopApi = {
  getStatus: async (): Promise<UloopConnectionStatus> => {
    const { data } =
      await instance.get<UloopConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (
    payload: UloopConnectPayload
  ): Promise<UloopConnectionStatus> => {
    const { data } = await instance.post<UloopConnectionStatus>(
      BASE_ENDPOINT_URL,
      payload
    );
    return data;
  },

  update: async (payload: {
    featured_opted_in: boolean;
  }): Promise<UloopConnectionStatus> => {
    const { data } = await instance.patch<UloopConnectionStatus>(
      BASE_ENDPOINT_URL,
      payload
    );
    return data;
  },

  disconnect: async (): Promise<UloopConnectionStatus> => {
    const { data } =
      await instance.delete<UloopConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  }
};
